import type { Routes } from '@angular/router';

import {
  adminGuard,
  authGuard,
  notAuthGuard,
  tosGuard,
} from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    canActivate: [notAuthGuard],
    loadChildren: () =>
      import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    // Deep link público de convite — `/i/:codigo`. Não exige auth.
    // Componente decide: se logado, chama mutation; se não, manda
    // pra /auth/login?returnUrl=/i/:codigo (sessionStorage guarda o código).
    path: 'i/:codigo',
    loadComponent: () =>
      import('./features/liga/aceitar-convite.page').then(
        (m) => m.AceitarConvitePage,
      ),
    title: 'Convite — Quer Apostar?',
  },
  {
    path: 'onboarding',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/onboarding/onboarding.page').then(
        (m) => m.OnboardingPage,
      ),
    title: 'Onboarding — Quer Apostar?',
  },
  {
    path: 'app',
    canActivate: [authGuard, tosGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/home/home.page').then((m) => m.HomePage),
        title: 'Quer Apostar?',
      },
      {
        path: 'ligas',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/liga/ligas-list.page').then(
                (m) => m.LigasListPage,
              ),
            title: 'Meus grupos — Quer Apostar?',
          },
          {
            path: 'criar',
            loadComponent: () =>
              import('./features/liga/ligas-criar.page').then(
                (m) => m.LigasCriarPage,
              ),
            title: 'Criar grupo — Quer Apostar?',
          },
          {
            path: 'entrar',
            loadComponent: () =>
              import('./features/liga/entrar-por-codigo.page').then(
                (m) => m.EntrarPorCodigoPage,
              ),
            title: 'Entrar via código — Quer Apostar?',
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./features/liga/liga-detalhe.page').then(
                (m) => m.LigaDetalhePage,
              ),
          },
          {
            path: ':ligaId/apostas/nova',
            loadComponent: () =>
              import('./features/aposta/criar-aposta-wizard.page').then(
                (m) => m.CriarApostaWizardPage,
              ),
            title: 'Nova aposta — Quer Apostar?',
          },
        ],
      },
      {
        path: 'apostas',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/aposta/apostas-list.page').then(
                (m) => m.ApostasListPage,
              ),
            title: 'Minhas apostas — Quer Apostar?',
          },
          {
            // IMPORTANTE: rotas literais ('nova-publica') ANTES de `:id`
            // — senão o router casa o id literal com a rota dinâmica.
            path: 'nova-publica',
            loadComponent: () =>
              import('./features/aposta/criar-aposta-publica.page').then(
                (m) => m.CriarApostaPublicaPage,
              ),
            title: 'Nova aposta pública — Quer Apostar?',
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./features/aposta/aposta-detalhe.page').then(
                (m) => m.ApostaDetalhePage,
              ),
          },
          {
            path: ':id/validar',
            loadComponent: () =>
              import('./features/aposta/validar.page').then(
                (m) => m.ValidarApostaPage,
              ),
            title: 'Validar aposta — Quer Apostar?',
          },
          {
            path: ':id/decidir',
            loadComponent: () =>
              import('./features/aposta/validar.page').then(
                (m) => m.ValidarApostaPage,
              ),
            data: { mode: 'owner' },
            title: 'Decidir aposta — Quer Apostar?',
          },
        ],
      },
      {
        path: 'feed',
        loadComponent: () =>
          import('./features/feed/feed.page').then((m) => m.FeedPage),
        title: 'Em destaque — Quer Apostar?',
      },
      {
        path: 'loja',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/loja/loja.page').then((m) => m.LojaPage),
            title: 'Loja — Quer Apostar?',
          },
          {
            path: 'pagar/:compraId',
            loadComponent: () =>
              import('./features/loja/pagamento.page').then(
                (m) => m.PagamentoPage,
              ),
            title: 'Pagamento — Quer Apostar?',
          },
        ],
      },
      {
        path: 'admin',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/admin.page').then((m) => m.AdminPage),
        title: 'Admin — Quer Apostar?',
      },
      {
        path: 'perfil',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/perfil/perfil.page').then((m) => m.PerfilPage),
            title: 'Perfil — Quer Apostar?',
          },
          {
            path: 'estatisticas',
            loadComponent: () =>
              import('./features/perfil/estatisticas.page').then(
                (m) => m.EstatisticasPage,
              ),
            title: 'Estatísticas — Quer Apostar?',
          },
        ],
      },
    ],
  },
  { path: '', redirectTo: '/app', pathMatch: 'full' },
  { path: '**', redirectTo: '/app' },
];
